import styled from 'styled-components';
import { Div } from 'common/styles/oc-styled-components';
import { Icon } from 'opencare-crown';

import { colors } from '../../../../../common/styles/style-constants';

export const IconContainer = styled(Div)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px auto;
`;

export const CheckCircleIcon = styled(Icon)`
  font-size: 64px;
  & svg {
    color: ${colors.sage6};
  }
`;
